import Vue from 'vue'
import VTooltip from 'v-tooltip'

// Global Components
const UiDivider = () =>
    import(
        /* webpackChunkName: "ui-divider" */ "@/components/layout/UiDivider.vue"
        );
const UiSubHeader = () =>
    import(
        /* webpackChunkName: "ui-subheader" */ "@/components/layout/UiSubHeader"
        );
const UiContent = () =>
    import(/* webpackChunkName: "ui-content" */ "@/components/layout/UiContent");
const UiCard = () =>
    import(/* webpackChunkName: "ui-card" */ "@/components/layout/UiCard");
const UiSpinner = () =>
    import(/* webpackChunkName: "ui-spinner" */ "@/components/layout/UiSpinner");

Vue.component("ui-divider", UiDivider);
Vue.component("ui-sub-header", UiSubHeader);
Vue.component("ui-content", UiContent);
Vue.component("ui-card", UiCard);
Vue.component("ui-spinner", UiSpinner);
Vue.use(VTooltip)
